<template>
  <div class="my-10 mx-12 ui-panel">
    <!-- <logo-component/> -->
    <logo-SVG />
    <range-slider label="Size" param="0" min="20" max="60" step="1" />
    <range-slider label="Complexity" param="1" min="0" max="1.25" step="0.01" />
    <palette-picker />

    <create-cell-button />
    <delete-cell-button />
    <button class="active-red-btn" @click="store.P5Instance.deleteBlobs">
      Clear all cells
    </button>

    <div class="export-dialog p-4">
      <div class="ml-2 text-lg">Export Settings</div>
      <div class="ml-2">
        <div v-for="(ops, i) in options" :key="i">
          <div class="mt-4 text-xs">{{ ops.name }}</div>
          <div class="flex">
            <div v-for="(op, j) in ops.options" :key="j">
              <button
                class="text-sm"
                :class="optionStyle(i, j)"
                @click="handleOptionsClick(i, j)"
              >
                {{ op.name }}
              </button>
            </div>
          </div>
          <div v-if="i == 0" class="text-xs text-gray-300">
            {{ options[0].options[activeOptions[0]].size }}x{{
              options[0].options[activeOptions[0]].size
            }}
          </div>
        </div>
      </div>
    </div>

    <div class="flex items-center justify-start">
    <button
      class="play-pause-btn text-lg  h-8 w-8 flex justify-center items-center"
      @click="store.runnerInstance.enabled = !store.runnerInstance.enabled"
      :class="{'spin-border':store.runnerInstance.enabled}"
    >
      <pause-SVG v-if="store.runnerInstance.enabled" />
      <play-SVG v-if="!store.runnerInstance.enabled" />
    </button>
    <button class="active-black-btn " @click="store.P5Instance.exportImage">
      Export Image
    </button>
    <record-button />
    </div>

    <record-panel />

    <div class="mx-2 my-2 text-xs text-right">{{ store.frameRate }} fps</div>
    <!-- <div v-if="store.findingCell" class="text-right">Finding cell...</div> -->
  </div>
</template>

<script>
import { store } from "../store";
import { palettes } from "../js/palettes";
import PalettePicker from "./PalettePicker";
import RangeSlider from "./RangeSlider";
import RecordPanel from "./RecordPanel";
import CreateCellButton from "./buttons/CreateCellButton.vue";
import DeleteCellButton from "./buttons/DeleteCellButton.vue";
import RecordButton from "./buttons/RecordButton.vue";
import LogoSVG from "./svg/LogoSVG";
import PauseSVG from "./svg/PauseSVG";
import PlaySVG from "./svg/PlaySVG";
export default {
  name: "UIControls",
  components: {
    PalettePicker,
    RangeSlider,
    RecordPanel,
    CreateCellButton,
    DeleteCellButton,
    RecordButton,
    LogoSVG,
    PauseSVG,
    PlaySVG,
  },
  created: function () {
    for (let i = 0; i < 2; i++) {
      store.exportOptions[i] = this.options[i].options[this.activeOptions[i]];
    }
  },
  data: () => ({
    store,
    palettes,
    activeOptions: [3, 0],
    options: [
      {
        name: "Size",
        options: [
          { name: "S", size: 1080 },
          { name: "M", size: 2160 },
          { name: "L", size: 4320 },
          { name: "XL", size: 10800 },
        ],
      },
      {
        name: "Length",
        options: [
          { name: "5s", duration: 5 },
          { name: "10s", duration: 10 },
          { name: "30s", duration: 30 },
          { name: "1min", duration: 60 },
        ],
      },
    ],
  }),
  methods: {
    handleOptionsClick: function (i, j) {
      this.activeOptions[i] = j;
      store.exportOptions[i] = this.options[i].options[j];
    },
    optionStyle: function (i, j) {
      return {
        "blue-btn": this.activeOptions[i] == j,
        "active-black-btn": this.activeOptions[i] != j,
      };
    },
  },
  computed: {
    deleteCellStyle() {
      return {
        "disabled-btn": !store.selectedBlob,
        "active-red-btn": store.selectedBlob,
      };
    },
  },
};
</script>

<style>
.selected-button {
  @apply bg-blue-600 text-white rounded-full py-1 px-3;
}
.base-btn {
  @apply py-1 px-3;
}

.add-button {
  @apply bg-transparent border-blue-200 overflow-visible border border-black rounded-full hover:bg-gray-400 hover:border-white hover:text-white;
}
.active-button {
  @apply bg-transparent border-blue-200 overflow-visible border border-black rounded-full hover:bg-gray-400 hover:border-white hover:text-white;
}

.clear-button {
  @apply bg-transparent rounded-full border text-black rounded-full border-black hover:bg-red-600;
}
.export-button {
  @apply bg-blue-700 text-white p-4 font-bold hover:bg-blue-900 m-1 w-full;
}

.export-dialog {
  @apply border border-gray-300 rounded-2xl p-2 my-4;
}

.ui-panel {
  width: 27%;
  overflow: visible;
}
</style>